if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

$(document).ready(function() {
    if($(".single_product_bundle").length != 0){
      function AllPriceInclueded() {
        let mainprice = $("#add_product_budle").data("price");
        let mainsellprice = $("#add_product_budle").data("sell-price");
        let mainpricecurrency = $("#add_product_budle").data("price-money");
        let mainpricesymbol = $("#add_product_budle").data("price-money-symbol");
        let allpriceqty = 0;
        $('.qty_input').each(function() {
          allpriceqty = parseInt(allpriceqty) + parseInt($(this).val());
        });      
        mainprice = parseFloat(mainprice) * parseInt(allpriceqty);  
        if(mainsellprice != ""){
          mainsellprice = parseFloat(mainsellprice) * parseInt(allpriceqty);
        }
        let withoutdiscount = mainprice;    
        let max_discount = 0;
        if($(".single_product_bundle_offer .block_bundle_offer").length != 0 && parseInt(allpriceqty) != 1){          
          let discount_length = $(".single_product_bundle_offer .block_bundle_offer[data-qty]").length + 1;          
          max_discount = $(".single_product_bundle_offer .block_bundle_offer[data-qty]:nth-child(" + discount_length + ")").data("discount");  
          if(parseInt(allpriceqty) > parseInt(discount_length)){
            mainprice = parseFloat(mainprice) - (parseFloat(mainprice) * parseInt(max_discount) / 100);
          }else{
            max_discount = $(".single_product_bundle_offer .block_bundle_offer[data-qty=" + parseInt(allpriceqty) + "]").data("discount");
            mainprice = parseFloat(mainprice) - (parseFloat(mainprice) * parseInt(max_discount) / 100);
          }
        }
        if($(".without_discounted_price").length == 0){
          $(".new_bundle_price__container > .price__regular").prepend("<span class='without_discounted_price'>" + mainpricesymbol + withoutdiscount.toFixed(2) + ' ' + mainpricecurrency + "</span>");
        }else{
          $(".new_bundle_price__container > .price__regular").find(".without_discounted_price").text(mainpricesymbol + withoutdiscount.toFixed(2) + " " + mainpricecurrency);
        }
        if(mainsellprice != ""){
          $(".new_bundle_price__container > .price__sale").find(".price-item.price-item--regular").text(mainpricesymbol + mainsellprice.toFixed(2) + " " + mainpricecurrency);
        }else{
          $(".new_bundle_price__container > .price__sale").find(".price-item.price-item--regular").text(mainpricesymbol + withoutdiscount.toFixed(2) + " " + mainpricecurrency);
        }
        $(".new_bundle_price__container > .price__sale").find(".price-item.price-item--sale").text(mainpricesymbol + mainprice.toFixed(2) + " " + mainpricecurrency);
        $(".new_bundle_price__container > .price__regular").find(".price-item.price-item--regular").text(mainpricesymbol + mainprice.toFixed(2) + " " + mainpricecurrency);
        if(allpriceqty == 1){
         $(".without_discounted_price").remove();
        }
        $(".main_price_block .discountrrp").remove();
        if(max_discount != 0){
          $(".main_price_block").append("<span class='discountrrp'>" + max_discount + "% OFF RRP</span>");
        }
        $("#main_bundle_price").text(mainpricesymbol + mainprice.toFixed(2) + " " + mainpricecurrency);
        var shadow = $('square-placement')[0].shadowRoot;
        var strongElement = $(shadow).find(".afterpay-main-text").find('strong');
        strongElement.text(mainpricesymbol + (mainprice.toFixed(2) / 4).toFixed(2));                
      }
      AllPriceInclueded();

      $("#add_product_budle").click(function() {
        $(this).addClass("loading");
        var items = [];
        $(".product_bundle_pack .block_pack").each(function () {
          var variantId = $(this).data("id");
          var quantity = $(this).find(".qty_input").val();          
          if (quantity > 0) {
            items.push({
              id: variantId,
              quantity: parseInt(quantity, 10)
            });
          }
        });  
        console.log(items);
        if (items.length > 0) {
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: { items: items },
            dataType: "json",
            success: function (response) {
              console.log(response);
              // window.location.href = "/cart";
              $('cart-drawer').addClass('active')
              $('cart-drawer').removeClass('is-empty');
              $('.drawer__inner-empty').hide();
              $('#CartDrawer').load(location.href + " #CartDrawer");
              $('#cart-icon-bubble').load(location.href + " #cart-icon-bubble");
              $("#add_product_budle").removeClass("loading");
            },
            error: function (xhr, status, error) {
              alert("Error adding products: " + xhr.responseJSON.description);
            }
          });
        } else {
          alert("Please select at least one product.");
        }
      });
    
      function isAnyInputAtMinValue() {
        let atMinValue = false;
        let allpriceqty = 0;
        $('.qty_input').each(function() {
          allpriceqty = parseInt(allpriceqty) + parseInt($(this).val());
        });
        if($('.qty_input[value=0]').length == 2 && allpriceqty == 1){
          atMinValue = true;
        }
        return atMinValue;
      }
  
      $('.qty_minus').click(function() {
        if (!isAnyInputAtMinValue()) {
          var input = $(this).siblings('.qty_input');
          var currentValue = parseInt(input.val(), 10);
          if (currentValue > 0) {
            input.val(currentValue - 1).attr("value", currentValue - 1);
          }
          AllPriceInclueded();
        }
      });
  
      $('.qty_plus').click(function() {
        var input = $(this).siblings('.qty_input');
        var currentValue = parseInt(input.val(), 10);
        input.val(currentValue + 1).attr("value", currentValue + 1);
        AllPriceInclueded();
      });
    }

    if($(".bundle_discovery_pack_custom_variant").length){
      function bundle_discount_pack(){
        let lip_balm_bundle_val = $("#lip-balm-bundle").val();
        let lip_balm_bundle = $("#lip-balm-bundle option[value='" + lip_balm_bundle_val + "']").attr('data-product-handle');
        let natural_deodorant_bundle_val = $("#natural-deodorant-bundle").val();
        let natural_deodorant_bundle = $("#natural-deodorant-bundle option[value='" + natural_deodorant_bundle_val + "']").attr('data-product-handle');
        let whipped_tallow_face_val = $("#whipped-tallow-face").val();
        let whipped_tallow_face = $("#whipped-tallow-face option[value='" + whipped_tallow_face_val + "']").attr('data-product-handle');
        let all_selected_value = $("ul#all_app_bundle_id").find("li[data-handle='discovery-pack_" + lip_balm_bundle + "_" + natural_deodorant_bundle + "_" + whipped_tallow_face + "']").text();
        console.log(all_selected_value);
        $("#selected_variant_input_id").val(all_selected_value);
      }      
      bundle_discount_pack();
      $(".bundle_discovery_pack_custom_variant .custom_variant_main select").on("change", function(){
        bundle_discount_pack();
      });      
    }    
});
